import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import text from "../helper/text";

const Wrapper = styled.div`
  width: 100%;
  padding: 25vh 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

class Loader extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (!this.props.translations) return null
    return (
      <Wrapper>
        <p>
          {text.get(
            this.props.translations,
            "The_page_you_requested_could_not_be_found"
          )}
        </p>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ translations }) => {
  return {
    translations: translations.data
  };
};

export default connect(mapStateToProps)(Loader);



// WEBPACK FOOTER //
// ./src/components/NotFound.js